import { render, staticRenderFns } from "./DraggableImg.vue?vue&type=template&id=6e574e3b&scoped=true"
import script from "./DraggableImg.vue?vue&type=script&lang=js"
export * from "./DraggableImg.vue?vue&type=script&lang=js"
import style0 from "./DraggableImg.vue?vue&type=style&index=0&id=6e574e3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e574e3b",
  null
  
)

export default component.exports